import { Button, styled, Typography } from "@mui/material";

export const BackButton = styled(Button)(() => ({ padding: 0, marginBottom: "0.5rem" }));

export const ButtonText = styled(Typography)(() => ({
  marginLeft: "1rem",
  fontWeight: 500,
}));
